import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export const isTaxNumber: ValidatorFn = Validators.pattern(
  `^([0-9]{8})-([1-5])-([0-9]{2})$`
);

export const taxNumberValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const regExp = '^([0-9]{8})-([1-5])-([0-9]{2})$';
  return String(control.value).match(new RegExp(regExp)) || !control.value
    ? null
    : { taxNumber: true };
};
